import type * as SchemaTypes from '../types';

import type { TranslatedStringDataFragment } from './TranslatedStringData';
import { gql } from '@apollo/client';
import { TranslatedStringDataFragmentDoc } from './TranslatedStringData';
export type TranslatedTextDataFragment = (
  { __typename: 'DealerTranslationText' }
  & { defaultValue: (
    { __typename: 'TranslatedString' }
    & TranslatedStringDataFragment
  ), overrides: Array<(
    { __typename: 'DealerTranslationTextOverride' }
    & Pick<SchemaTypes.DealerTranslationTextOverride, 'dealerId'>
    & { value: (
      { __typename: 'TranslatedString' }
      & TranslatedStringDataFragment
    ) }
  )> }
);

export const TranslatedTextDataFragmentDoc = /*#__PURE__*/ gql`
    fragment TranslatedTextData on DealerTranslationText {
  defaultValue {
    ...TranslatedStringData
  }
  overrides {
    dealerId
    value {
      ...TranslatedStringData
    }
  }
}
    `;